<template>
    <div>
        <ul class="option-ul">
            <li class="option-li" id="nav-area">
                <div class="select">
                    <span>地区选择：{{area}}</span>
                </div>
                <div id="area-select" class="btn">
                    <ul>
                        <li v-for="(item) in areas" v-bind:key="item" @click="changeArea(item)">{{item}}</li>
                    </ul>
                </div>
            </li>
            <li class="option-li" id="nav-time">
                <div class="select">
                    <span>时间选择：{{time}}</span>
                </div>
                <div id="time-select" class="btn">
                    <ul>
                        <li v-for="(item) in times" v-bind:key="item" @click="changeTime(item)">{{item}}</li>
                    </ul>
                </div>
            </li>
            <li class="option-li" id="nav-type">
                <div class="select">
                    <span>行业选择：{{type}}</span>
                </div>
                <div id="type-select" class="btn">
                    <ul>
                        <li v-for="(item) in types" v-bind:key="item" @click="changeType(item)">{{item}}</li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import {Province} from "../../network/utils";
    import {Type} from "../../network/utils";

    export default {
        name: "Selectv2",
        props: ['clickCity'],
        data() {
            return {
                area: "全国",
                areas: [],
                time: "全部时间",
                times: ['全部时间', '最近一月', '最近一季度', '最近一年'],
                type: "全部行业",
                types: []
            }
        },
        methods: {
            changeArea(item) {
                this.area = item
            },
            changeType(item) {
                this.type = item
            },
            changeTime(item) {
                this.time = item
            },
            postArea(val) {
                this.$emit('postArea', val)
            },
            postTime(val) {
                this.$emit('postTime', val)
            },
            postType(val) {
                this.$emit('postType', val)
            }
        },
        watch: {
            area(val) {
                this.postArea(val)
            },
            time(val) {
                this.postTime(val)
            },
            type(val) {
                this.postType(val)
            },
            clickCity(val) {
                this.area = val
            }
        },

        created() {
           Province().then(response => {
                let li = [];
                li.push("全国");
                for (let i = 0; i < response.data.length; i++) {
                    li.push(response.data[i]['city'])
                }
                this.areas = li
            }).catch(function (error) {
                console.log(error)
            });
            Type().then(response => {
                let li = [];
                li.push("全部行业");
                for (let i = 0; i < response.data.length; i++) {
                    li.push(response.data[i]['type_name'])
                }
                this.types = li
            }).catch(function (error) {
                console.log(error)
            })
        }


    }
</script>

<style scoped>

    .option:hover {
        /*box-shadow: 6px 6px 6px #2271b7;*/
    }

    .option-ul {
        display: flex;
        /*width: 500px;*/
        height: 50px;
        /*align-items: center;*/
        /*justify-content: center;*/
    }

    .option-li {
        /*width: 300px;*/
        padding-right: 20px;
        padding-left: 20px;
        height: 40px;;
    }

    .select {
        width: 100%;
        height: 100%;
        margin-top: 10px;
    }

    .option-li:hover {
        cursor: pointer;
        color: #ffffff;
        /*background-color: #2271b7;*/
        box-shadow: 3px 2px 3px #ffffff inset;
    }

    .btn ul li:hover {
        background-color: #1b2947;
        color: #f7f7f7;

    }

    #area-select ul li {

        align-items: center;
        justify-content: center;
        /*margin-left: 20px;*/
        /*margin-right: 20px;*/
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        float: left;
        width: 90px;
        /*color: #f7f7b8;*/

    }

    #area-select {
        width: 180px;
        height: 550px;
        box-shadow: 3px 2px 3px #ffffff inset;
        position: relative;
        background-color: #5b466e;
        opacity: 0.8;
        transform: translate(0px, -700px);
        transition: 0.5s;
        z-index: -1;
    }

    #nav-area:hover #area-select {
        transform: translate(-0px, -10px);
        color: #f7f7b8;

    }

    #time-select {
        width: 100px;
        height: 140px;
        background-color: #5b466e;
        box-shadow: 3px 2px 3px #2271b7 inset;
        position: relative;
        opacity: 0.8;
        transform: translate(0px, -300px);
        transition: 0.5s;
        z-index: -1;
    }

    #nav-time:hover #time-select {
        transform: translate(-0px, -10px);
        color: #f7f7b8;
    }

    #time-select ul li {

        align-items: center;
        justify-content: center;
        /*margin-left: 20px;*/
        /*margin-right: 20px;*/
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        /*float: left;*/
        /*width: 90px;*/

    }

    /*#eia-type-select {*/
    /*    width: 100px;*/
    /*    height: 70px;*/
    /*    box-shadow: 3px 2px 3px #2271b7 inset;*/
    /*    position: relative;*/
    /*    !*background-color: #dfebf5;*!*/
    /*    transform: translate(0px, -120px);*/
    /*    transition: 0.5s;*/
    /*    z-index: -1;*/
    /*}*/

    #nav-eia-type:hover #eia-type-select {
        transform: translate(-0px, -10px);
        color: #f7f7b8;
    }

    #eia-type-select ul li {

        align-items: center;
        justify-content: center;
        /*margin-left: 20px;*/
        /*margin-right: 20px;*/
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        /*float: left;*/
        /*width: 90px;*/

    }

    #type-select {
        /*overflow: scroll;*/
        width: 550px;
        height: 680px;
        box-shadow: 3px 2px 3px #2271b7 inset;

        position: relative;
        background-color: #5b466e;
        opacity: 0.8;
        transform: translate(0px, -950px);
        transition: 0.5s;
        z-index: -1;

    }

    #nav-type:hover #type-select {
        transform: translate(-0px, -10px);
        color: #f7f7b8;
    }

    #type-select ul li {

        align-items: center;
        justify-content: center;
        /*margin-left: 20px;*/
        /*margin-right: 20px;*/
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        float: left;
        /*width: 90px;*/

    }


</style>